export enum ResumeMode {
  PARSED = 'plaintext',
  ORIGINAL = 'preview'
}
